/** Mint d’un lien portail (ouvrir / copier) depuis la fiche. */
import { useState } from "react";
import { facturxFetch } from "../../api/client";
import { useCompany } from "../../company/CompanyProvider";
import { portalFromCompany } from "../../portal/types";
import type { Client } from "./types";

export function useClientPortalLink(client: Client) {
  const { company } = useCompany();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [copied, setCopied] = useState(false);
  const portal = portalFromCompany(company);
  const owner = Boolean(company?.is_owner);
  const enabled = portal.enabled;

  async function mint(): Promise<string> {
    if (!company) throw new Error("Aucune société.");
    const data = await facturxFetch<{ url: string }>("portal-link.php", {
      method: "POST",
      body: JSON.stringify({ company_id: company.id, client_id: client.id }),
    });
    return data.url;
  }

  async function openPortal() {
    setBusy(true);
    setErr("");
    try {
      const url = await mint();
      window.open(url, "_blank", "noopener");
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Erreur");
    } finally {
      setBusy(false);
    }
  }

  async function copyLink() {
    setBusy(true);
    setErr("");
    setCopied(false);
    try {
      const url = await mint();
      try {
        await navigator.clipboard.writeText(url);
      } catch {
        window.prompt("Lien", url);
      }
      setCopied(true);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Erreur");
    } finally {
      setBusy(false);
    }
  }

  return { enabled, owner, busy, err, copied, openPortal, copyLink };
}
